import React from "react";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <div className="container py-5">

      {/* Hero Section */}
      <div className="row align-items-center mb-5">
        <div className="col-md-6">
          <h1 className="display-5 fw-bold mb-3">
            Welcome to <span className="text-primary">MCQ BD</span>
          </h1>
          <p className="lead">
            Judicial Service Preparation • Bar Council • Job Exams • University  
            সব ধরনের MCQ আপনাকে এখানে প্র্যাকটিস করতে পারবেন।
            Subject-wise, Chapter-wise সম্পূর্ণ ফ্রি!
          </p>
          <Link to="/exam" className="btn btn-primary btn-lg mt-3">
            Start Practice Now →
          </Link>
        </div>

        <div className="col-md-6 text-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            alt="MCQ Icon"
            className="img-fluid"
            style={{ maxWidth: "280px" }}
          />
        </div>
      </div>

      {/* Features Section */}
      <div className="row text-center mt-5">
        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="fw-bold text-primary">✔ 10+ Subjects</h4>
            <p>CrPC, CPC, Penal Code, Evidence Act, Tax, Ethics, Limitation & More</p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="fw-bold text-success">✔ Unlimited Practice</h4>
            <p>Google Sheet থেকে অটো ডাটা লোড হয়—সকল MCQ আপডেটেড</p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="fw-bold text-danger">✔ Timer + Scoreboard</h4>
            <p>Real-time scoring system • Attempted • Accuracy Everything</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-center mt-5">
        <Link to="/exam" className="btn btn-dark btn-lg px-5 py-3">
          Start Exam Practice →
        </Link>
      </div>
    </div>
  );
}
